import React, { useCallback, useState } from 'react';

import { Button, Checkbox, Row, Col, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import MyModal from 'v2/components/Shared/MyModal';

interface IProps {
  onAccept: () => void;
}

export const SelectIntroduction = ({ onAccept }: IProps) => {
  const [open, setOpen] = useState(false);

  const onConfirm = useCallback(() => {
    setOpen(false);
    if (onAccept) onAccept();
  }, [onAccept]);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Row gutter={[16, 16]} justify='center' align='middle' className='text-center'>
        <Col span={24}>
          <Typography.Title level={5}>Você deseja trabalhar com afiliados?</Typography.Title>
        </Col>
        <Col span={24} className='max-w-150'>
          <Typography.Text>
            O programa de afiliados e o marketing de afiliados é a melhor estratégia para capitalizar as vendas do seu
            produto sem realizar grandes investimentos. Comece a trabalhar com afiliados agora mesmo!
          </Typography.Text>
        </Col>
        <Col span={24}>
          <Button type='primary' onClick={() => setOpen(true)} icon={<Icon.Users  />}>
            Habilitar vendas por afiliados
          </Button>
        </Col>
      </Row>
      <Confirm open={open} onClose={onClose} onConfirm={onConfirm} />
    </>
  );
};

const Confirm = ({ open, onClose, onConfirm }: { open: boolean; onClose: () => void; onConfirm: () => void }) => {
  const [accept, setAccept] = useState<boolean>(false);
  return (
    <MyModal
      title='Vendas por afiliados'
      opened={open}
      onClose={onClose}
      onSubmit={onConfirm}
      submitDisabled={!accept}
      buttonOk='Habilitar vendas por afiliados'
      buttonCancel='Agora não'
    >
      Ao habilitar e salvar o produto com a funcionalidade de vendas por afiliados, esteja ciente que ela não poderá ser
      desabilitada.
      <Checkbox checked={accept} onChange={() => setAccept(v => !v)} className='mt-4!'>
        Estou de acordo com a política de vendas por afiliados
      </Checkbox>
    </MyModal>
  );
};
